import { datadogLogs, LogsEvent } from '@datadog/browser-logs';

if (import.meta.env.VITE_STAGE) {
  datadogLogs.init({
    clientToken: 'pubba6358a62ff2141a5ad133911c4d5251',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    telemetrySampleRate: 100,
    telemetryUsageSampleRate: 100,
    telemetryConfigurationSampleRate: 100,
    service: import.meta.env.VITE_STAGE + '-create-platform-client',
    useSecureSessionCookie: true,
    beforeSend: (event: LogsEvent) => {
      if (event.message.includes('.m3u8') || event.message.includes('ResizeObserver')) {
        return false;
      }
      return true;
    },
  });
}
